import dashboardAnalyticsService from '@/services/dashboard-anaylitics/dashboard-analytics.service';

type DashboardAnalyticsStateType = {
  data: any;
  dateRange: {
    startDate: Date;
    endDate: Date;
  };
};

const getInitialState = (): DashboardAnalyticsStateType => {
  return {
    data: null,
    dateRange: {
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      endDate: new Date(),
    },
  };
};

const dashboardAnalyticsModule = {
  namespaced: true,
  state: getInitialState(),
  mutations: {
    SET_DASHBOARD_ANALYTICS(state, payload) {
      state.data = payload;
    },
    SET_DATE_RANGE(state, payload) {
      state.dateRange = payload;
    },
  },
  actions: {
    async fetchDashboardAnalytics({ commit, state }) {
      const { startDate, endDate } = state.dateRange;
      const response: any =
        await dashboardAnalyticsService.getDashboardAnalytics(
          startDate.toISOString().split('T')[0],
          endDate.toISOString().split('T')[0],
        );
      commit('SET_DASHBOARD_ANALYTICS', response.data);
    },
    setDateRange({ commit }, payload) {
      commit('SET_DATE_RANGE', payload);
    },
  },
  getters: {
    getDashboardAnaylitics(state) {
      return state.data;
    },
  },
};

export default dashboardAnalyticsModule;
